import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { isCampaignPartOfFullySharedBudget } from '../../../common-campaign-form/config/campaignsGroupBudgetDistributionMethod';
import EMPTY_FIELD_VALUE from '../../config/defaultValues';
import FormattedNumberCellRenderer from './FormattedNumberCellRenderer';
import LabelLayoutCellRenderer from './LabelLayoutCellRenderer';

class SpendingLimitCellRenderer extends Component {
    render() {
        const { value, data, ...rest } = this.props;
        const { campaignGroupInfo } = data;

        const msgIdPrefix = 'app.campaigns.campaign.budget.type';
        const spendingLimitType = get(data, 'budget.spendingLimit.type', null);
        const msgId = spendingLimitType ? `${msgIdPrefix}.${spendingLimitType}` : null;

        if (isCampaignPartOfFullySharedBudget(campaignGroupInfo?.campaignsGroupBudgetDistributionMethod)) {
            return EMPTY_FIELD_VALUE;
        }

        return (
            <LabelLayoutCellRenderer msgId={msgId}>
                <div>{value ? <FormattedNumberCellRenderer value={value} {...rest} /> : EMPTY_FIELD_VALUE}</div>
            </LabelLayoutCellRenderer>
        );
    }
}

SpendingLimitCellRenderer.propTypes = {
    /** spending limit value */
    value: PropTypes.number,
    /** data which is injected by the grid - The row data object */
    data: PropTypes.object,
};

export default SpendingLimitCellRenderer;
